// Note: The first file of a module here, must also register the module

import "./choose-campaign-column.component";
import "./choose-import-data-type.component";
import "./confirm-import.component";
import "./delete-import-data.component";
import "./field-picker.component";
import "./import-error.component";
import "./import-skipped.component";
import "./voter-file-conflict.component";
import "./voter-file-import.component";
import "./voter-file-import-info.component";
import "./voter-file-l2.component";
import "./voter-file-list.component";
import "./voter-file-progress-leader.component";
import "./import-tabs.component";
import "./edit-import-name.component";
